import { createFileRoute } from '@tanstack/react-router';
import { InsightsGlobalDiagram } from '@/app/(client)/supply-chain-mapping/-components/insights/InsightsGlobalDiagram';
import { useGlobalDiagram } from '@/app/(client)/supply-chain-mapping/-hooks/useGlobalDiagram';
import { PageContainer } from '@/components/shared/PageContainer';
import { QueryErrorState } from '@/components/shared/QueryErrorState';
import { useTranslator } from '@/hooks/useTranslator';

export const Route = createFileRoute(
  '/(client)/supply-chain-mapping/(pages)/(list)/insights/global-diagram/',
)({
  component: InsightsGlobalDiagramPage,
});

function InsightsGlobalDiagramPage() {
  const { getTranslation: t } = useTranslator({ page: 'supplyChainMapping' });
  const { data, isLoading, error, refetch } = useGlobalDiagram();

  if (isLoading) {
    return (
      <div className='flex items-center justify-center h-64 text-xs text-muted-foreground'>
        {t('insights.globalDiagram.loading')}
      </div>
    );
  }

  if (error) {
    return <QueryErrorState error={error} onRetry={() => refetch()} />;
  }

  return (
    <PageContainer>
      <InsightsGlobalDiagram
        nodes={data?.companies ?? []}
        edges={data?.edges ?? []}
      />
    </PageContainer>
  );
}
